import { ApiGame } from "../../src/types/apigame";
import GamesListGame from "./gameslist/gameslistgame";
import styles from './gameslist.module.css';

export enum GameGamesListViewMode {
    Standard = 0,
    Compact = 1,
}

type Props = {
    games: ApiGame[];
    userId: number;
}

export default function GameGamesList(
    {
        games,
        userId,
    }: Props,
) {
    return (
        <div className={styles.gamesList}>
            {
                games.map(
                    (game) => (
                        <GamesListGame key={game.id} game={game} userId={userId} />
                    ),
                )
            }
        </div>
    );
}
